import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex justify-between flex-nowrap" }
const _hoisted_2 = {
  ref: "zonesContent",
  class: "w-537 h-screen flex flex-col justify-between flex-nowrap transition-all duration-300 ease-in-out transform-x"
}
const _hoisted_3 = { class: "pt-14 px-5 relative" }
const _hoisted_4 = { class: "px-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "ml-2 text-lightRed font-semibold text-xs leading-4" }, "Close the map", -1)
const _hoisted_6 = { class: "flex justify-between mb-7" }
const _hoisted_7 = { class: "flex justify-start" }
const _hoisted_8 = { class: "relative h-42 w-288 me-3" }
const _hoisted_9 = { class: "h-full" }
const _hoisted_10 = {
  key: 0,
  class: "bg-white opacity-100 z-40",
  style: {"width":"50%"}
}
const _hoisted_11 = {
  key: 1,
  class: "bg-white opacity-100 z-40",
  style: {"width":"25%"}
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  key: 1,
  class: "flex justify-start flex-wrap"
}
const _hoisted_16 = { class: "flex justify-end gap-6" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "relative" }
const _hoisted_19 = {
  key: 0,
  class: "store-badge absolute rounded-full bg-green-600 text-white text-center"
}
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = {
  key: 0,
  class: "text-center text-darkText text-lg px-4 mt-32 font-bold"
}
const _hoisted_24 = {
  ref: "zonesMap",
  class: "h-screen z-10 h-full calculated-width transition-all duration-300 ease-in-out"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseIcon = _resolveComponent("BaseIcon")!
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_SearchInput = _resolveComponent("SearchInput")!
  const _component_TableGhost = _resolveComponent("TableGhost")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_ZoneMap = _resolveComponent("ZoneMap")!
  const _component_BaseModal = _resolveComponent("BaseModal")!
  const _component_ZoneDarkStoreSettings = _resolveComponent("ZoneDarkStoreSettings")!
  const _component_ConfirmationModal = _resolveComponent("ConfirmationModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              (_ctx.shortTable)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.startAnimation())),
                    class: "z-20 cursor-pointer absolute -right-18 top-110 ps-1 py-2 bg-white rounded-6 rounded transform -rotate-90"
                  }, [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_BaseIcon, {
                        style: {"width":"12px"},
                        name: "redarrow"
                      }),
                      _hoisted_5
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_PageTitle, { title: "zones.list" }),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_SearchInput, {
                      placeholder: _ctx.$t('zones.search'),
                      modelValue: _ctx.searchValue,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchValue) = $event))
                    }, null, 8, ["placeholder", "modelValue"])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("button", {
                    class: "primary flex items-center px-5 py-3",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/zones/add-new')))
                  }, [
                    _createVNode(_component_BaseIcon, {
                      name: "plus",
                      classNames: "text-xl me-1"
                    }),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('buttons.addNewZone')), 1)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", {
                style: _normalizeStyle({height: _ctx.height + 'px'}),
                class: "tableFixHead px-5"
              }, [
                _createElementVNode("table", null, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", {
                        class: "bg-white opacity-100 z-40",
                        style: _normalizeStyle(_ctx.shortTable ? 'width: 80%' : 'width: 25%')
                      }, _toDisplayString(_ctx.$t('table.name')), 5),
                      (!_ctx.shortTable)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_10, _toDisplayString(_ctx.$t('table.darkstores')), 1))
                        : _createCommentVNode("", true),
                      (!_ctx.shortTable)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_11))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  (!_ctx.loading)
                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_12, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.zones, (zone, zIndex) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: zone.id
                          }, [
                            _createElementVNode("td", null, _toDisplayString(zone.name), 1),
                            (!_ctx.shortTable)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_13, [
                                  (!zone.darkstores.length)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, "-"))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(zone.darkstores, (ds, i) => {
                                          return (_openBlock(), _createElementBlock("span", {
                                            class: "my-1 rounded bg-backgroundPurple me-2 leading-3 flex justify-center items-center h-6 text-xs text-purple px-1.5 py-1 border border-purple",
                                            key: i
                                          }, _toDisplayString(ds.name), 1))
                                        }), 128))
                                      ]))
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("td", _hoisted_16, [
                              _createElementVNode("button", {
                                onClick: () => _ctx.selectedZone = zone
                              }, [
                                _createElementVNode("div", _hoisted_18, [
                                  (zone.darkstores.length)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(zone.darkstores.length), 1))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_BaseIcon, { name: "store" })
                                ])
                              ], 8, _hoisted_17),
                              _createElementVNode("button", {
                                onClick: ($event: any) => (_ctx.$router.push(`/zones/edit/${zone.id}`))
                              }, [
                                _createVNode(_component_BaseIcon, { name: "edit" })
                              ], 8, _hoisted_20),
                              _createElementVNode("button", {
                                onClick: ($event: any) => (_ctx.shortTable ? _ctx.highlightIndex = zIndex : _ctx.showDetails(zone))
                              }, [
                                _createVNode(_component_BaseIcon, { name: "mappin" })
                              ], 8, _hoisted_21),
                              _createElementVNode("button", {
                                onClick: ($event: any) => (_ctx.selectedZoneToDelete = zone)
                              }, [
                                _createVNode(_component_BaseIcon, { name: "trash" })
                              ], 8, _hoisted_22)
                            ])
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.loading)
                    ? (_openBlock(), _createBlock(_component_TableGhost, {
                        key: 1,
                        "col-margin": "my-0",
                        row: 10,
                        col: 3
                      }))
                    : _createCommentVNode("", true)
                ]),
                (!_ctx.zones.length && !_ctx.loading)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_23, _toDisplayString(_ctx.$t('validation.noItemsToShow')), 1))
                  : _createCommentVNode("", true)
              ], 4)
            ]),
            _createElementVNode("div", null, [
              (_ctx.pagination && _ctx.pagination.totalItems)
                ? (_openBlock(), _createBlock(_component_Pagination, {
                    key: 0,
                    current: _ctx.current,
                    total: _ctx.pagination.totalItems,
                    "page-range": 2,
                    basicPagination: _ctx.shortTable,
                    "per-page": _ctx.pagination.pageSize,
                    onPageChanged: _cache[3] || (_cache[3] = ($event: any) => (_ctx.current = $event)),
                    "text-before-input": "Go to page"
                  }, null, 8, ["current", "total", "basicPagination", "per-page"]))
                : _createCommentVNode("", true)
            ])
          ], 512),
          _createElementVNode("div", _hoisted_24, [
            _createVNode(_component_ZoneMap, {
              id: "all-zone-view",
              coordinatesGroup: _ctx.allZoneCoordinates,
              drawEnabled: false,
              editablePolygon: false,
              draggablePolygon: false,
              highlightIndex: _ctx.highlightIndex,
              zoom: 13
            }, null, 8, ["coordinatesGroup", "highlightIndex"])
          ], 512)
        ])
      ]),
      _: 1
    }),
    (_ctx.showZoneDetails)
      ? (_openBlock(), _createBlock(_component_BaseModal, {
          key: 0,
          title: _ctx.showZoneDetails.name,
          width: '746',
          onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showZoneDetails = null))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ZoneMap, {
              coordinatesGroup: _ctx.showZoneDetails.polygon,
              editablePolygon: false,
              draggablePolygon: false,
              drawEnabled: false,
              style: {"height":"500px"},
              zoom: 13
            }, null, 8, ["coordinatesGroup"])
          ]),
          _: 1
        }, 8, ["title"]))
      : _createCommentVNode("", true),
    (_ctx.selectedZone)
      ? (_openBlock(), _createBlock(_component_BaseModal, {
          key: 1,
          title: _ctx.selectedZone.name,
          width: '746',
          onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectedZone = null))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ZoneDarkStoreSettings, {
              zone: _ctx.selectedZone,
              onSync: _ctx.onSync
            }, null, 8, ["zone", "onSync"])
          ]),
          _: 1
        }, 8, ["title"]))
      : _createCommentVNode("", true),
    (_ctx.selectedZoneToDelete)
      ? (_openBlock(), _createBlock(_component_ConfirmationModal, {
          key: 2,
          header: _ctx.$t('zones.deleteConfirmation.header'),
          hasIcon: false,
          title: _ctx.$t('zones.deleteConfirmation.title', [_ctx.selectedZoneToDelete.name]),
          cancelText: _ctx.$t('buttons.no'),
          confirmText: _ctx.$t('buttons.yesDelete'),
          onConfirm: _ctx.deleteZone,
          onCancel: _cache[6] || (_cache[6] = ($event: any) => (_ctx.selectedZoneToDelete = null))
        }, null, 8, ["header", "title", "cancelText", "confirmText", "onConfirm"]))
      : _createCommentVNode("", true)
  ], 64))
}